import * as React from 'react';
import { StyleSheet, View } from 'react-native';

import PremiumIcon from './premium.svg';

interface Props {
	children: React.ReactNode;
	size: number;
	isPremium: boolean;
}

export const PremiumIndicator = ({ children, size, isPremium }: Props) => (
	<View
		style={{
			height: size,
			width: size,
		}}
	>
		{children}

		{isPremium && <PremiumIcon width={size * 0.5} height={size * 0.5} style={styles.premiumIcon} />}
	</View>
);

const styles = StyleSheet.create({
	premiumIcon: {
		position: 'absolute',
		top: '-15%',
		right: '-15%',
	},
});
